import { cssVar } from "@/utils";
import { createTheme } from "@mui/material";
import "@mui/material/styles";

// Currently described as max-width, MUI deals with min-width. Do calculations to convert to min-width
const ModusCMXBreakpoints = {
  xs: 575, // @media screen and (max-width: 575)
  sm: 767, // @media screen and (min-width: 576px) and (max-width: 767px)
  md: 991, // @media screen and (min-width: 768px) and (max-width: 991px)
  lg: 1199, // @media screen and (min-width: 992px) and (max-width: 1199px)
  xl: 1200, // @media screen and (min-width: 1200px)
};

declare module "@mui/material/styles" {
  interface TypographyVariants {
    fontWeightSemiBold: React.CSSProperties["fontWeight"];
  }

  interface TypographyVariantsOptions {
    fontWeightSemiBold?: React.CSSProperties["fontWeight"];
  }
}

const uxTheme = createTheme({
  typography: {
    fontFamily: "Open Sans",
  },
  palette: {
    primary: {
      // main: cssVar("--modus-wc-color-primary"), // issue with 'light-dark' css function
      main: cssVar("--modus-wc-color-trimble-blue"),
      light: cssVar("--modus-wc-color-trimble-blue"),
      dark: cssVar("--modus-wc-color-highlight-blue"),
      // contrastText: cssVar("--modus-wc-color-white"),
    },
    secondary: {
      // main: cssVar("--modus-wc-color-secondary"),
      main: cssVar("--modus-wc-color-yellow"),
      light: cssVar("--modus-wc-color-yellow"),
      dark: cssVar("--modus-wc-color-yellow-light"),
      // contrastText: cssVar("--modus-wc-color-secondary-content"),
    },
    background: {
      default: cssVar("--modus-wc-color-gray-light"),
    },
    // Revisit this color when Modus is better understood
    info: {
      // main: cssVar("--modus-wc-color-info"),
      main: cssVar("--modus-wc-color-blue-dark"),
      light: cssVar("--modus-wc-color-blue-dark"),
      dark: cssVar("--modus-wc-color-blue-light"),
      // contrastText: cssVar("--modus-wc-color-info-content"),
    },
    success: {
      // main: cssVar("--modus-wc-color-success"),
      main: cssVar("--modus-wc-color-green"),
      light: cssVar("--modus-wc-color-green"),
      dark: cssVar("--modus-wc-color-green-light"),
      // contrastText: cssVar("--modus-wc-color-white"),
    },
    error: {
      // main: cssVar("--modus-wc-color-error"),
      main: cssVar("--modus-wc-color-red"),
      light: cssVar("--modus-wc-color-red"),
      dark: cssVar("--modus-wc-color-red-light"),
      // contrastText: cssVar("--modus-wc-color-white"),
    },
    warning: {
      // main: cssVar("--modus-wc-color-warning"),
      main: cssVar("--modus-wc-color-yellow-dark"),
      light: cssVar("--modus-wc-color-yellow-dark"),
      dark: cssVar("--modus-wc-color-yellow-light"),
      // contrastText: cssVar("--modus-wc-color-warning-content"),
    },
  },
  shape: {
    borderRadius: 8,
  },
  breakpoints: {
    values: {
      xs: 0, // No media query, default css
      sm: ModusCMXBreakpoints.xs + 1, // @media (min-width: 576px)
      md: ModusCMXBreakpoints.sm + 1, // @media (min-width: 768px)
      lg: ModusCMXBreakpoints.md + 1, // @media (min-width: 992px)
      xl: ModusCMXBreakpoints.lg + 1, // @media (min-width: 1200px)
    },
  },
});

export default uxTheme;
